import { configFetch as fetch } from '@meiqia/utils';

// 获取快捷回复列表
export const getQuickRepliesApi = () => {
  return fetch({
    url: '/agent/quick_replies',
    method: 'get'
  });
};
